import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../../authmanagement/dialog/message-dialog/message-dialog.component'
import { Cons, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, map, startWith, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

import * as XLSX from 'xlsx';
import { LocationsService } from 'src/app/features/locations-map/services/Locations.service';
import { SwalNotificationService } from 'src/app/features/shared/services/SwalNotification.service';
import { LocationUserModel } from '../../models/locations-user.model';

@Component({
  selector: 'app-admin-vin-control',
  templateUrl: './admin-vin-control.component.html',
  styleUrls: ['./admin-vin-control.component.css']
})
export class AdminVinControlComponent implements OnInit,OnDestroy {

  @ViewChild('autocompleteInput', {static: true}) autocompleteInput: ElementRef;
  @Output() IdentifierList = new EventEmitter<string>();
  @Input() IdentifierListInput: string;
  @Input() client: string;
  @Input() filtersList: any;
  @Input() clientNumber: number;
  
  private lastFiltersCalled: string = '';

  locationObjects: LocationUserModel[] = [];
  placeHolder = 'VIN o Identificador';
  selectedItemsLabel = 'Activo(s) Seleccionado(s)';
  selectedItems: { identifier: string, checked: boolean }[] = [];
  myControl = new FormControl('');
  filteredOptions: Observable<LocationUserModel[]> = new Observable<LocationUserModel[]>();
  excelFileUrl: any;
  identifierErrores: string[] = [];
  isLoading: boolean = false;
  file: any;
  isSelectedItems: boolean = false;
  fileName: string = 'Ninguno';

  subscription_getList: Subscription;
  subscription_validateIdentifier: Subscription;
  
  constructor(
    private dialog: MatDialog, 
    private notifyService: SwalNotificationService, 
    private locationService: LocationsService) 
  {
    
  }

  ngOnInit() {

    if(this.IdentifierListInput != null && this.IdentifierListInput != ''){
      this.selectedItems = this.getArrayFromString(this.IdentifierListInput);
      if(this.selectedItems.length>0)
        this.isSelectedItems = true;
      else
        this.isSelectedItems = false;
    }

    this.getLocationsList();
    this.setFilteredOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.client && this.client) {
      this.getLocationsList();
    }

    if (changes.filtersList) {
      console.log("stringOutPut filtersList",this.filtersList, this.locationObjects);
      this.getLocationsList();
    }
    
    if(changes.IdentifierListInput && this.IdentifierListInput != null && this.IdentifierListInput != ''){
      this.selectedItems = this.getArrayFromString(this.IdentifierListInput);
      if(this.selectedItems.length>0){
        this.isSelectedItems = true;
        var stringOutPut = this.getStringFromSelectedItems();
        this.IdentifierList.emit(stringOutPut);
      }
      else
        this.isSelectedItems = false;

    }
  }

  ngOnDestroy() {
    if (this.subscription_getList) 
      this.subscription_getList.unsubscribe();
    if (this.subscription_validateIdentifier) 
      this.subscription_validateIdentifier.unsubscribe();
  }

  private _filter(value: string): LocationUserModel[] {
    if (!value || value.trim() === '') {
      return this.locationObjects.slice(0, 50);
    }
    // this.getLocationsList();
    const filterValue = value.toLowerCase();
    const filteredLocations = this.locationObjects.filter(option => option.identifier.toLowerCase().includes(filterValue) || option.description.toLowerCase().includes(filterValue));

    return filteredLocations.slice(0, 50);
  }

  getLocationsList() {
    // verifica si se va a necesitar la lista de ubicaciones con una nueva petición
    const currentFilters = JSON.stringify({
      client: this.client,
      groups: this.filtersList?.Groups || '',
      subGroups: this.filtersList?.SubGroups || ''
    });

    if (this.lastFiltersCalled === currentFilters && this.locationObjects.length > 0) {
      return;
    }

    var groupList = '';
    var subGroupList = '';
    if (this.filtersList != null && this.filtersList != undefined) {
      groupList = this.filtersList.Groups;
      subGroupList = this.filtersList.SubGroups;
    }
    if (this.subscription_getList) {
      this.subscription_getList.unsubscribe();
    }
    this.subscription_getList = this.locationService.getByClientList(this.client, groupList, subGroupList).subscribe((data) => {
      this.locationObjects = data.result as LocationUserModel[];
      this.myControl.updateValueAndValidity();
      if (this.selectedItems.length > 0) {
        // Filtrar los elementos seleccionados basados en los nuevos datos filtrados
        this.selectedItems = this.selectedItems.filter(item => 
          this.locationObjects.some(object => object.identifier === item.identifier)
          );
          
          const stringOutput = this.getStringFromSelectedItems();
          console.log("stringOutPut final",this.selectedItems);
          
          this.IdentifierList.emit(stringOutput);
          console.log("stringOutPut filtersList 2",this.filtersList, this.locationObjects);
      }
    });
  }

  addSelectedItem(event: MouseEvent) {
    event.stopPropagation();
    const inputValue = this.autocompleteInput.nativeElement.value;
    if (inputValue && !this.selectedItems.find(item => item.identifier === inputValue)) {
      this.selectedItems.push({identifier: inputValue, checked: true });
      this.autocompleteInput.nativeElement.value = '';
      var stringOutPut = this.getStringFromSelectedItems();
      this.IdentifierList.emit(stringOutPut);
    } else if(inputValue && this.selectedItems.find(item => item.identifier === inputValue)){
      this.notifyService.message(
        "Ya se encuentra seleccionado ese VIN"
      );
      this.autocompleteInput.nativeElement.value = '';
    }else{
      this.notifyService.message(
        "No se ha seleccionado ningun VIN"
      );
      this.autocompleteInput.nativeElement.value = '';
    }
    if(this.selectedItems.length>0)
        this.isSelectedItems = true;
      else
        this.isSelectedItems = false;
  }

  addAllSelectedItem(event: MouseEvent) {
    event.stopPropagation();
    var newSelectedItems = [];
    this.locationObjects.forEach(item => {
      if (!this.selectedItems.find(selectedItem => selectedItem.identifier === item.identifier)) {
        this.selectedItems.push({identifier: item.identifier, checked: true });
        newSelectedItems.push(item.identifier);
      }
    });
    if (newSelectedItems.length>0 ) {
      this.autocompleteInput.nativeElement.value = '';
      var stringOutPut = this.getStringFromSelectedItems();
      this.IdentifierList.emit(stringOutPut);
    } else if(newSelectedItems.length == 0 ){
      this.notifyService.message(
        "Ya se encuentran seleccionados todos los VIN"
      );
      this.autocompleteInput.nativeElement.value = '';
    }
    if(this.selectedItems.length>0)
        this.isSelectedItems = true;
      else
        this.isSelectedItems = false;
  }

  deleteAllItems(event: any) {  
    this.notifyService.confirmMessage("Eliminar todos", "Seguro que quieres eliminar todos los objetos?").then((result) => {
      if (result.value) {
        this.selectedItems = [];
        var stringOutPut = this.getStringFromSelectedItems();
        this.IdentifierList.emit(stringOutPut);
        this.isSelectedItems = false;
      }
    });
  }

  openGenericDialog(message: string) {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '400px',
      data: message,
      panelClass: 'dialog-container-custom'
    });
  }

  onItemChange(item: any) {
    item.checked = !item.checked;
    if (!item.checked) {
      const index = this.selectedItems.indexOf(item);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
        var stringOutPut = this.getStringFromSelectedItems();
        this.IdentifierList.emit(stringOutPut);
        if(this.selectedItems.length>0)
        this.isSelectedItems = true;
      else
        this.isSelectedItems = false;
      }
    }
  }

  getStringFromSelectedItems() {
    let result = '';
    this.selectedItems.forEach(item => {
      result += item.identifier + ',';
    });
    return result;
  }

  stringToCommaSeparatedArray(string: string) {
    return string.split(',');
  }

  getArrayFromString(string: string) {  
    let array = this.stringToCommaSeparatedArray(string);
    let result: { identifier: string, checked: boolean }[] = [];
    array.forEach(item => {
      result.push({ identifier: item, checked: true });
    });
    return result;
  }

  sendFileInput(event: any) {
    var error = true;
    if (this.client == null || this.client == '') {
      this.notifyService.MessageError(
        "No hay cliente, Seleccione un cliente principal para poder validar los identificadores"
      );
      return;
    }
    
    console.log("file",this.file);
    if (this.file) {
      
      const fileExtension = this.file.name.split('.').pop().toLowerCase();

    if (fileExtension === 'xlsx' || fileExtension === 'xls') {
      this.isLoading = true;
      try {
        const reader = new FileReader();
        var listaVINS = [];
  
        reader.onload = (e: any) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
    
          // El rango de celdas está en la hoja 'Sheet1' en la columna 'A' desde la fila 2 hasta la última fila.
          const sheetName = 'Hoja1';
          const range = {
            s: { r: 1, c: 0 }, // Empieza en la fila 1 (sin contar la 0, para el titulo) y columna 0 (A)
            e: { r: XLSX.utils.decode_range(workbook.Sheets[sheetName]['!ref']).e.r, c: 0 } // Termina en la última fila de datos en la columna 0
          };
    
          const worksheet = workbook.Sheets[sheetName];
          const columnData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range });
    
          // Almacena los datos en un array
           const excelDataArray = columnData.map(row => row[0]);
          excelDataArray.forEach( (dataItem) => {
            if (dataItem != null && dataItem != undefined && dataItem != '') {
              listaVINS.push(dataItem.toString());
            }
           });

          //Validar los identificadores
        this.subscription_validateIdentifier = this.locationService.postValidateIdentifiers(listaVINS, this.client).subscribe((data)=>{
          console.log(data);
          
          if (data.isSuccess) {
            this.identifierErrores = data.result.invalidIdentifiers;
            var identificadoresValidados = data.result.validIdentifiers;
            
            identificadoresValidados.forEach( (dataItem) => {
              if (!this.selectedItems.find(item => item.identifier === dataItem) && this.locationObjects.find(item => item.identifier === dataItem)) {
                this.selectedItems.push({identifier: dataItem, checked: true });
                this.autocompleteInput.nativeElement.value = '';
                var stringOutPut = this.getStringFromSelectedItems();
                this.IdentifierList.emit(stringOutPut);
              } else {
                this.autocompleteInput.nativeElement.value = '';
              }
            });
            if (this.identifierErrores.length > 0) {
              this.notifyService.MessageSuccessful(
                "Archivo correcto",
                "Se han cargado los vines a la lista, excepto: " + this.identifierErrores
              );
              this.isLoading = false;
              error = false;
            }
            else{
              this.notifyService.MessageSuccessful(
                "Archivo correcto",
                "Se han cargado los vines a la lista"
              );
              this.isLoading = false;
              error = false;
            }
          }else{
            this.notifyService.MessageError(
              "Error al validar los identificadores"
            );
            this.isLoading = false;
            error = false;
          }
        });
      };

        reader.readAsArrayBuffer(this.file);
        
        

      } catch (error) {
        this.notifyService.MessageError(
          "Archivo incorrecto, Seleccione un archivo xlsx"
        );
        this.isLoading = false;
        error = false;
      }
    }else{
      this.notifyService.MessageError(
        "Archivo incorrecto, Seleccione un archivo xlsx"
      );
      this.isLoading = false;
      error = false;
    }
    }
    else{
      this.notifyService.message(
        "Adjunte por favor un archivo plantilla con los identificadores a cargar"
      );
    }
  }

  updateFileInput(event){
    this.file = event.target.files[0];
    this.fileName = this.file.name;
    
  }

  
  exportToExcel(fileName: string) {
    const workSheet = XLSX.utils.aoa_to_sheet([
      ['VINs'],
      ['EJEMPLO000000001'],
      ['EJEMPLO000000002'],
      ['EJEMPLO000000003']
    ]);
  
    // Establecer el ancho de la columna A si es necesario
    const wscols = [{ wpx: 300 }];
    workSheet['!cols'] = wscols;
  
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Hoja1');
    XLSX.writeFile(workBook, `${fileName}.xlsx`);
  }
  
  setFilteredOptions(){
    this.filteredOptions = this.myControl.valueChanges
     .pipe(
       startWith(''),
       debounceTime(150),
       distinctUntilChanged(),
       map(value => this._filter(value))
     );
  }
  
}
